import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  InputAdornment,
  Fade,
  Stack,
  alpha,
  useTheme,
} from "@mui/material";
import {
  Edit,
  PhoneInTalk,
  VerifiedUser,
  Send,
  MobileFriendly,
} from "@mui/icons-material";

export default function PhoneStep({
  phoneFormik,
  isCodeSent,
  phoneNumber,
  handleChangePhone,
  handleResendCode 
}) {
  const theme = useTheme();
  return (
    <Fade in timeout={400}>
      <form onSubmit={phoneFormik.handleSubmit}>
        <Stack spacing={3}>
          <Box sx={{ textAlign: "center" }}>
            <PhoneInTalk sx={{ fontSize: 54, color: "primary.main", mb: 2 }} />
            <Typography variant="h5" gutterBottom fontWeight="bold">
              {!isCodeSent
                ? "به خانواده همکاری خوش اومدی!"
                : "تایید شماره موبایل"}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {!isCodeSent
                ? "برای شروع، شماره موبایل خود را وارد کن"
                : `کد ۵ رقمی ارسال شده به ${phoneNumber} را وارد کن`}
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontSize: ".9rem", mb: "8px" }}>
              شماره همراه
            </Typography>
            <TextField
              fullWidth
              name="phone"
              placeholder="۰۹۱۲۳۴۵۶۷۸۹"
              value={phoneFormik.values.phone}
              onChange={phoneFormik.handleChange}
              onBlur={phoneFormik.handleBlur}
              error={
                phoneFormik.touched.phone && Boolean(phoneFormik.errors.phone)
              }
              helperText={phoneFormik.touched.phone && phoneFormik.errors.phone}
              disabled={isCodeSent}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 3,
                  backgroundColor: alpha(theme.palette.common.white, 0.03),
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MobileFriendly color="primary" />
                  </InputAdornment>
                ),
                endAdornment: isCodeSent && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleChangePhone}
                      sx={{
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                      }}
                    >
                      <Edit />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          {isCodeSent && (
            <Stack spacing={2}>
              <TextField
                fullWidth
                name="verificationCode"
                label="کد تایید"
                placeholder="۱۲۳۴۵"
                value={phoneFormik.values.verificationCode}
                onChange={phoneFormik.handleChange}
                onBlur={phoneFormik.handleBlur}
                error={
                  phoneFormik.touched.verificationCode &&
                  Boolean(phoneFormik.errors.verificationCode)
                }
                helperText={
                  phoneFormik.touched.verificationCode &&
                  phoneFormik.errors.verificationCode
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 3,
                    backgroundColor: alpha(theme.palette.common.white, 0.03),
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <VerifiedUser color="secondary" />
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="text"
                onClick={handleResendCode}
                sx={{ alignSelf: "center" }}
              >
                ارسال مجدد کد
              </Button>
            </Stack>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disabled={
              (isCodeSent && !phoneFormik.values.verificationCode) ||
              (!isCodeSent && !phoneFormik.values.phone)
            }
            sx={{
              py: 1.5,
              fontSize: ".9rem",
            }}
          >
            {!isCodeSent ? (
              <Send sx={{ ml: 1, fontSize: "1.3rem" }} />
            ) : (
              <VerifiedUser sx={{ ml: 1, fontSize: "1.3rem" }} />
            )}
            {!isCodeSent ? "ارسال کد تایید" : "تایید و ادامه"}
          </Button>
        </Stack>
      </form>
    </Fade>
  );
}
